// ============================================================
// ByOurConsent.com -- Footer Component
// ============================================================

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
    const location = useLocation();
    return (
        <>
            {/* Join bar */}
            <div style={{
                background:     '#1e2a3a',
                padding:        '1.1rem 1.5rem',
                display:        'flex',
                alignItems:     'center',
                justifyContent: 'space-between',
                gap:            '1.5rem',
                flexWrap:       'wrap'
            }}>
                <div>
                    <div style={{ fontSize: '16px', color: '#e8dfc8', marginBottom: '2px', fontFamily: "'EB Garamond', Georgia, serif" }}>
                        Stay informed. Stay engaged.
                    </div>
                    <div style={{ fontSize: '11px', fontFamily: 'sans-serif', color: '#6a7a8a' }}>
                        No spam. No party line. Just news and analysis worth reading.
                    </div>
                </div>
                <Link to="/register" state={{ backgroundLocation: location }}
                    style={{
                        background:    '#8b1a1a',
                        color:         '#f5f0e8',
                        padding:       '9px 24px',
                        fontSize:      '11px',
                        fontFamily:    'sans-serif',
                        letterSpacing: '0.08em',
                        textTransform: 'uppercase',
                        textDecoration:'none',
                        borderRadius:  '3px',
                        whiteSpace:    'nowrap'
                    }}>
                    Join the movement →
                </Link>
            </div>

            {/* Footer links */}
            <div style={{
                background:     '#141c26',
                padding:        '0.8rem 1.5rem',
                display:        'flex',
                alignItems:     'center',
                justifyContent: 'space-between',
                flexWrap:       'wrap',
                gap:            '6px'
            }}>
                <div style={{ display: 'flex', gap: '16px' }}>
                    {[
                        { to: '/privacy',    label: 'Privacy'    },
                        { to: '/terms',      label: 'Terms'      },
                        { to: '/disclaimer', label: 'Disclaimer' },
                        { to: '/contact',    label: 'Contact'    },
                    ].map(({ to, label }) => (
                        <Link key={to} to={to} style={{
                            fontSize:       '11px',
                            fontFamily:     'sans-serif',
                            color:          '#5a6a7a',
                            textDecoration: 'none'
                        }}>
                            {label}
                        </Link>
                    ))}
                </div>
                <div style={{
                    fontSize:   '11px',
                    fontFamily: 'sans-serif',
                    color:      '#3a4a5a'
                }}>
                    © {new Date().getFullYear()} ByOurConsent.com
                    &nbsp;·&nbsp;
                    Est. 1776 / Reclaimed 2026
                    &nbsp;·&nbsp;
                    No party affiliation
                </div>
            </div>
        </>
    );
};

export default Footer;
